export default () => ({
  efficiency: null,
  portfolios: null,
})
